<template>
    <div>
      <h1>复制表单</h1>
      <form @submit.prevent="submitForm">
        <div>
          <label for="oldTable">旧表名称:</label>
          <input type="text" v-model="oldTable" required />
        </div>
        <div>
          <label for="newTable">新表名称:</label>
          <input type="text" v-model="newTable" required />
        </div>
        <div>
          <label for="excel">Excel 文件:</label>
          <input type="file" @change="handleFileUpload" required />
        </div>
        <button type="submit">提交</button>
      </form>
      <div v-if="message">{{ message }}</div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        oldTable: '',
        newTable: '',
        excelFile: null,
        message: ''
      };
    },
    methods: {
      handleFileUpload(event) {
        this.excelFile = event.target.files[0];
      },
      async submitForm() {
        try {
          const formData = new FormData();
          formData.append('oldTable', this.oldTable);
          formData.append('newTable', this.newTable);
          formData.append('excel', this.excelFile);
  
          const response = await axios.post('/xjby/table/copy', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
  
          this.message = response.data;
        } catch (error) {
          this.message = '提交失败: ' + error.response.data;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  form {
    max-width: 400px;
    margin: 0 auto;
  }
  div {
    margin-bottom: 10px;
  }
  button {
    padding: 5px 10px;
  }
  </style>
  